import { api, routes } from "../helpers/api";
import { TRequestAppointmentData } from "../types/type";

export const sendAppointmentData = async (data: TRequestAppointmentData) => {
    const result = await api.post(routes.server + '/landing/email/specialist', data)
    return result;
}